import * as L from "react";
import { forwardRef as t } from "react";
const n = t(function(r, e) {
  return /* @__PURE__ */ L.createElement(
    "svg",
    {
      fill: "none",
      ref: e,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ L.createElement(
      "path",
      {
        d: "M8.87993 16.6077C9.37654 16.9895 9.76488 17.6799 10.0278 18.7188L10.084 18.9549L10.1312 19.1764L10.1475 19.2488C7.93473 20.6296 5.94174 21.2728 4.59681 20.8918L8.87911 16.6077H8.87993ZM19.882 3.30288L3.30316 19.8822C2.49555 18.4143 3.34875 15.8449 5.30103 13.0165L5.45571 12.7967L5.76996 12.3619C6.15667 11.8384 6.57839 11.3084 7.03267 10.7776L7.37949 10.3787L7.77841 9.93657C8.35269 9.30989 8.94957 8.70431 9.56786 8.12102L9.93666 7.77745L10.3795 7.37851C10.8939 6.92305 11.4236 6.48533 11.9679 6.0661L12.3619 5.76975L12.7959 5.45549C15.7104 3.39406 18.3759 2.47489 19.882 3.30288ZM12.068 13.4211C14.5104 15.8636 11.7098 21.64 11.0243 18.8702C10.5684 17.0237 10.1728 16.0932 9.83897 16.0769L9.62974 15.8677L9.62567 15.8636L12.068 13.4211ZM20.8916 4.59656C21.3206 6.10844 20.4536 8.44098 18.6991 10.9836L18.5444 11.2034L18.2302 11.6381C17.828 12.1809 17.4068 12.7094 16.9675 13.2225L16.6206 13.6214L16.2217 14.0635C15.6474 14.6902 15.0506 15.2958 14.4323 15.879L14.0635 16.2226L14.0333 16.2495C13.9954 14.9764 13.5303 13.753 12.7128 12.7763L20.8916 4.59575V4.59656Z",
        fill: "currentColor"
      }
    )
  );
});
export {
  n as Surfing
};
